import NsStandout from '@britishgasenergy/react-nucleus/dist/nuc-components/NsStandout';

export const testId = 'nonSupplyInfoTestId';

type NonSupplyInfoProps = {
  shouldShow: boolean;
};

export const NonSupplyInfo = ({ shouldShow }: NonSupplyInfoProps) => {
  if (!shouldShow) return null;

  return (
    <NsStandout decoration="orange" data-testid={testId}>
      <h5>Why stay with British Gas?</h5>
      <p>
        We’re the UK’s leading energy provider, supplying gas and electricity to
        more than 8 million homes and businesses. And we’ve been around for over
        200 years, so you can be sure we’re here to stay.
      </p>
    </NsStandout>
  );
};